import type { TPublisherSong } from '@modules/types'

interface ShareTextParams {
  requestTitle?: string
  distributionTerritory?: string
  plannedPublicationDate?: string
  selectedSongs: TPublisherSong[]
  sharedUrl?: string
  sharedPassword?: string
}

export const formatShareText = ({
  requestTitle,
  distributionTerritory,
  plannedPublicationDate,
  selectedSongs,
  sharedUrl,
  sharedPassword,
}: ShareTextParams): string => {
  const songsList = selectedSongs
    .map((song, index) => {
      const { clientRequestSong } = song
      return `${index + 1}. ${clientRequestSong?.title} - ${clientRequestSong?.writers}`
    })
    .join('\n')

  const sections = [
    'PUBLICATION REQUEST',
    '='.repeat(50),
    '',
    'Details:',
    `   Title: ${requestTitle || 'Not specified'}`,
    distributionTerritory ? `   Territory: ${distributionTerritory}` : '',
    plannedPublicationDate ? `   Publication Date: ${plannedPublicationDate}` : '',
    '',
    `Requested Songs (${selectedSongs.length}):`,
    songsList,
    '',
    'Access Information:',
    `   Review Link: ${sharedUrl || 'Not provided'}`,
    `   Password: ${sharedPassword || 'Not provided'}`,
    '',
  ]

  return sections.join('\n')
}
